import React from 'react';
import { globalScheme } from '../../global.styles';

import EventUebersicht from '../event-uebersicht/event-uebersicht.component';
import KalenderUebersicht from '../kalender-uebersicht/kalender-uebersicht.component';
import {KalenderEventContainer} from './kalender-collection.styles';

function nextDay(weekday,addedWeekdays){
  let now = new Date();    
  now.setDate(now.getDate() + addedWeekdays + (weekday+(7-now.getDay())) % 7);
  return now;
}

function formatDate(now) {
  return new Intl.DateTimeFormat('de-DE', { month: 'long', day: '2-digit', year: 'numeric' }).format(now);
}

class KalenderCollection extends React.Component {
  constructor() {
    super();
    this.state = {
      dates: [
        {
          id: 0,
          title: "Training",
          date: nextDay(2,0),
          formattedDate: formatDate(nextDay(2,0)),
          time: '18:00 - 20:00 Uhr',
          description: "Training am Dienstag",
          color: globalScheme.darkgreen
        },
        {
          id: 1,
          title: "Training",
          date: nextDay(4,0),
          formattedDate: formatDate(nextDay(4,0)),
          time: '18:00 - 20:00 Uhr',
          description: "Training am Donnerstag",
          color: globalScheme.darkgreen
        },
        {
          id: 2,
          title: "Training",
          date: nextDay(2,7),
          formattedDate: formatDate(nextDay(2,7)),
          time: '18:00 - 20:00 Uhr',
          description: "Training am Dienstag",
          color: globalScheme.darkgreen
        },
        {
          id: 3,
          title: "Training",
          date: nextDay(4,7),
          formattedDate: formatDate(nextDay(4,7)),
          time: '18:00 - 20:00 Uhr',
          description: "Training am Donnerstag",
          color: globalScheme.darkgreen
        },
        {
          id: 4,
          title: "Training",
          date: nextDay(2,14),
          formattedDate: formatDate(nextDay(2,14)),
          time: '18:00 - 20:00 Uhr',
          description: "Training am Dienstag",
          color: globalScheme.darkgreen
        },
        {
          id: 5,
          title: "Training",
          date: nextDay(4,14),
          formattedDate: formatDate(nextDay(4,14)),
          time: '18:00 - 20:00 Uhr',
          description: "Training am Donnerstag",
          color: globalScheme.darkgreen
        }
      ],
    };
  }

  render() {
    return (
      <KalenderEventContainer>
        <KalenderUebersicht {...this.state} />
        <EventUebersicht {...this.state} />
      </KalenderEventContainer>
    )
  }
  
}
  
export default KalenderCollection;